import { Injectable } from '@angular/core';
import { HttpClientService } from '@app/core/http-client/http-client.service';
import { services } from '@app/core/settings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RemarksService {

  private static readonly endpoint = 'Remarks';
  constructor(private http: HttpClientService) { }

  getActiveRemarkList(): Observable<{ id: number, name: string }[]> {
    return this.http.get<{ id: number, name: string }[]>(`${RemarksService.endpoint}/GetActiveRemarkList`, undefined, services.orderService);
  }
}
